import React from 'react'
import { IIconProps } from 'Interfaces'

export function CloseIcon(props: IIconProps) {
    return (
        <svg width={props.width ?? 16} height={props.height ?? 16} viewBox="0 0 16 16" fill="none">
            <path d="M14.5846 2.27694L13.7231 1.41541L8.00002 7.13848L2.27694 1.41541L1.41541 2.27694L7.13848 8.00002L1.41541 13.7231L2.27694 14.5846L8.00002 8.86156L13.7231 14.5846L14.5846 13.7231L8.86156 8.00002L14.5846 2.27694Z" fill={props.color ?? "currentColor"}/>
        </svg>
    )
}